export const CHANNEL_PKG_LIST = [
    ['createTime', '时间'],
    ['channelName', '渠道包名称'],
    ['platform', '包体位数'],
    ['versionName', '渠道包版本'],
    ['versionCode', 'Version Code'],
    ['status', '状态'],
    ['operate', '操作'],
]

export const CHANNEL_PKG_STATUS = {
    WAIT_AUDIT: 1 << 0, // 待审核
    AUDIT_PASS: 1 << 1, // 上线
    AUDIT_FAIL: 1 << 2, // 审核失败
    OFFLINE: 1 << 3, // 下线
}

export const CHANNEL_PKG_STATUS_NAME = {
    [CHANNEL_PKG_STATUS.WAIT_AUDIT]: '待审核',
    [CHANNEL_PKG_STATUS.AUDIT_PASS]: '上线',
    [CHANNEL_PKG_STATUS.AUDIT_FAIL]: '审核失败',
    [CHANNEL_PKG_STATUS.OFFLINE]: '下线',
}
export const CHANNEL_PKG_STATUS_TIPS = {
    NEED_TO_UPDATE: '版本与主线包不一致，请及时替换',
}

export const ALLOWED_REPLACE_STATUS = [CHANNEL_PKG_STATUS.AUDIT_PASS]

export const CHANNEL_PKG_STATUS_LIST = [
    {
        label: '全部',
        value: -1,
    },
].concat(
    Object.values(CHANNEL_PKG_STATUS).map(status => {
        return {
            label: CHANNEL_PKG_STATUS_NAME[status],
            value: status,
        }
    })
)

export const PLATFORM_NAME = {
    0: '未知',
    1: '32位',
    2: '64位',
    3: '32-64兼容',
}

export const PLATFORM_VALUE = {
    Unknow: 0,
    Bit32: 1,
    Bit64: 2,
    Bit32And64: 3,
}
